import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';

export type InputProps = TextFieldProps & {
  label?: string;
  error?: boolean | string;
};

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, label, error, helperText, ...props }, ref) => {

    let errorText = typeof error === 'string' ? error : helperText;
    let hasError = !!error;

    return (
      <TextField
        inputRef={ref}
        label={label}
        error={hasError}
        helperText={errorText}
        fullWidth
        variant="outlined"
        size="small"
        className={className}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';
